import { render, staticRenderFns } from "./CommonPhrase.vue?vue&type=template&id=b9ef0e66&scoped=true&"
import script from "./CommonPhrase.vue?vue&type=script&lang=js&"
export * from "./CommonPhrase.vue?vue&type=script&lang=js&"
import style0 from "./CommonPhrase.vue?vue&type=style&index=0&id=b9ef0e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ef0e66",
  null
  
)

component.options.__file = "CommonPhrase.vue"
export default component.exports